import React, { FunctionComponent } from "react";

const ArrowsUpIcon: FunctionComponent = () => {
  // https://www.streamlinehq.com/icons/streamline-regular/arrows-diagrams/arrows/arrow-up-1
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14">
      <path
        d="M.5,10.15,6.65,4a.48.48,0,0,1,.7,0l6.15,6.15"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
    </svg>
  );
};

export default ArrowsUpIcon;
